// extracted by mini-css-extract-plugin
export var errorBanner = "_c2-2";
export var scroller = "_c2-0";
export var thinking = "_c2-1";
export var visuallyHidden = "_c2-3";